// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file kitecorp/transferify/account/v1/account_attribution.proto (package kitecorp.transferify.account.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import { file_kitecorp_options_v1_options } from "../../../options/v1/options_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file kitecorp/transferify/account/v1/account_attribution.proto.
 */
export const file_kitecorp_transferify_account_v1_account_attribution: GenFile = /*@__PURE__*/
  fileDesc("CjlraXRlY29ycC90cmFuc2ZlcmlmeS9hY2NvdW50L3YxL2FjY291bnRfYXR0cmlidXRpb24ucHJvdG8SH2tpdGVjb3JwLnRyYW5zZmVyaWZ5LmFjY291bnQudjEiuQgKGFN1Ym1pdEF0dHJpYnV0aW9uUmVxdWVzdBJdCgdjaGFubmVsGAEgASgOMkwua2l0ZWNvcnAudHJhbnNmZXJpZnkuYWNjb3VudC52MS5TdWJtaXRBdHRyaWJ1dGlvblJlcXVlc3QuQXR0cmlidXRpb25DaGFubmVsEhQKDGxhbmRpbmdfcGF0aBgCIAEoCRISCgVnY2xpZBgDIAEoCUIDgAEBEhMKBmdicmFpZBgEIAEoCUIDgAEBEhMKBndicmFpZBgFIAEoCUIDgAEBEhQKB3JkdF9jaWQYBiABKAlCA4ABARIQCgNmYmMYByABKAlCA4ABARIQCgNmYnAYCCABKAlCA4ABARIUCgdtc2Nsa2lkGAkgASgJQgOAAQESEgoKdXRtX3NvdXJjZRgKIAEoCRIUCgx1dG1fY2FtcGFpZ24YCyABKAkSEwoLdXRtX2NvbnRlbnQYDCABKAkSFQoNcmVmZXJyZXJfaG9zdBgNIAEoCSLDBQoSQXR0cmlidXRpb25DaGFubmVsEiMKH0FUVFJJQlVUSU9OX0NIQU5ORUxfVU5TUEVDSUZJRUQQABI0Ch9BVFRSSUJVVElPTl9DSEFOTkVMX1BBSURfU0VBUkNIEAEaD4K1GAtwYWlkLXNlYXJjaBI0Ch9BVFRSSUJVVElPTl9DSEFOTkVMX1BBSURfU09DSUFMEAIaD4K1GAtwYWlkLXNvY2lhbBIsChtBVFRSSUJVVElPTl9DSEFOTkVMX09SR0FOSUMQAxoLgrUYB29yZ2FuaWMSIgoWQVRUUklCVVRJT05fQ0hBTk5FTF9BSRAEGgaCtRgCYWkSKgoaQVRUUklCVVRJT05fQ0hBTk5FTF9TT0NJQUwQBRoKgrUYBnNvY2lhbBIuChxBVFRSSUJVVElPTl9DSEFOTkVMX1JFRkVSUkFMEAYaDIK1GAhyZWZlcnJhbBIqChpBVFRSSUJVVElPTl9DSEFOTkVMX0RJUkVDVBAHGgqCtRgGZGlyZWN0EjoKIkFUVFJJQlVUSU9OX0NIQU5ORUxfUkVDSVBJRU5UX1BBR0UQCBoSgrUYDnJlY2lwaWVudC1wYWdlEkQKJ0FUVFJJQlVUSU9OX0NIQU5ORUxfUkVDSVBJRU5UX1BBR0VfR0FNRRAJGheCtRgTcmVjaXBpZW50LXBhZ2UtZ2FtZRJKCipBVFRSSUJVVElPTl9DSEFOTkVMX1JFQ0lQSUVOVF9QQUdFX0NPTlRST0wQChoagrUYFnJlY2lwaWVudC1wYWdlLWNvbnRyb2wSNgogQVRUUklCVVRJT05fQ0hBTk5FTF9SRVFVRVNUX1BBR0UQCxoQgrUYDHJlcXVlc3QtcGFnZRI8CiNBVFRSSUJVVElPTl9DSEFOTkVMX1JFRkVSUkFMX0lOVklURRAMGhOCtRgPcmVmZXJyYWwtaW52aXRlMo4BChlBY2NvdW50QXR0cmlidXRpb25TZXJ2aWNlEnEKEVN1Ym1pdEF0dHJpYnV0aW9uEjkua2l0ZWNvcnAudHJhbnNmZXJpZnkuYWNjb3VudC52MS5TdWJtaXRBdHRyaWJ1dGlvblJlcXVlc3QaFi5nb29nbGUucHJvdG9idWYuRW1wdHkiCYq1GAUKA3VzZUJKCi1jb20ua2l0ZWNvcnAuY29udHJhY3RzLnRyYW5zZmVyaWZ5LmFjY291bnQudjFCF0FjY291bnRBdHRyaWJ1dGlvblByb3RvUAFiBnByb3RvMw", [file_google_protobuf_empty, file_kitecorp_options_v1_options]);

/**
 * The landing a browser read, as the attribution record keeps it. Every string is optional in the sense that an empty
 * value means the browser read none; the server trims each one and treats a blank as absent.
 *
 * @generated from message kitecorp.transferify.account.v1.SubmitAttributionRequest
 */
export type SubmitAttributionRequest = Message<"kitecorp.transferify.account.v1.SubmitAttributionRequest"> & {
  /**
   * The channel of the landing. ATTRIBUTION_CHANNEL_UNSPECIFIED means none was read; a number this schema does not
   * know is refused.
   *
   * @generated from field: kitecorp.transferify.account.v1.SubmitAttributionRequest.AttributionChannel channel = 1;
   */
  channel: SubmitAttributionRequest_AttributionChannel;

  /**
   * The path of the landing page, without the query string.
   *
   * @generated from field: string landing_path = 2;
   */
  landingPath: string;

  /**
   * The Google Ads click identifier. A log hides it, because it ties a click to a person.
   *
   * @generated from field: string gclid = 3;
   */
  gclid: string;

  /**
   * The Google click identifier for app events from iOS 14 and later. A log hides it.
   *
   * @generated from field: string gbraid = 4;
   */
  gbraid: string;

  /**
   * The Google click identifier for web events from iOS 14 and later. A log hides it.
   *
   * @generated from field: string wbraid = 5;
   */
  wbraid: string;

  /**
   * The Reddit Ads click identifier. A log hides it.
   *
   * @generated from field: string rdt_cid = 6;
   */
  rdtCid: string;

  /**
   * Meta's click identifier. A log hides it.
   *
   * @generated from field: string fbc = 7;
   */
  fbc: string;

  /**
   * Meta's browser id. A log hides it.
   *
   * @generated from field: string fbp = 8;
   */
  fbp: string;

  /**
   * The Microsoft Ads click identifier. A log hides it.
   *
   * @generated from field: string msclkid = 9;
   */
  msclkid: string;

  /**
   * The utm_source label of the landing.
   *
   * @generated from field: string utm_source = 10;
   */
  utmSource: string;

  /**
   * The utm_campaign label of the landing.
   *
   * @generated from field: string utm_campaign = 11;
   */
  utmCampaign: string;

  /**
   * The utm_content label of the landing.
   *
   * @generated from field: string utm_content = 12;
   */
  utmContent: string;

  /**
   * The host of the page that referred the visitor.
   *
   * @generated from field: string referrer_host = 13;
   */
  referrerHost: string;
};

/**
 * Describes the message kitecorp.transferify.account.v1.SubmitAttributionRequest.
 * Use `create(SubmitAttributionRequestSchema)` to create a new message.
 */
export const SubmitAttributionRequestSchema: GenMessage<SubmitAttributionRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_account_v1_account_attribution, 0);

/**
 * The channel the landing came through, spelled in the REST body by the wire_value of each value. The values are
 * those of kitecorp.measurement.v1.AttributionChannel.
 *
 * @generated from enum kitecorp.transferify.account.v1.SubmitAttributionRequest.AttributionChannel
 */
export enum SubmitAttributionRequest_AttributionChannel {
  /**
   * No channel. Also how a landing with only click identifiers or campaign labels reads.
   *
   * @generated from enum value: ATTRIBUTION_CHANNEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * A search ad click.
   *
   * @generated from enum value: ATTRIBUTION_CHANNEL_PAID_SEARCH = 1;
   */
  PAID_SEARCH = 1,

  /**
   * A social ad click.
   *
   * @generated from enum value: ATTRIBUTION_CHANNEL_PAID_SOCIAL = 2;
   */
  PAID_SOCIAL = 2,

  /**
   * A search engine referred the visitor.
   *
   * @generated from enum value: ATTRIBUTION_CHANNEL_ORGANIC = 3;
   */
  ORGANIC = 3,

  /**
   * An AI assistant referred the visitor.
   *
   * @generated from enum value: ATTRIBUTION_CHANNEL_AI = 4;
   */
  AI = 4,

  /**
   * A social site referred the visitor, or one of our own hand-posted social links was followed.
   *
   * @generated from enum value: ATTRIBUTION_CHANNEL_SOCIAL = 5;
   */
  SOCIAL = 5,

  /**
   * Any other website referred the visitor.
   *
   * @generated from enum value: ATTRIBUTION_CHANNEL_REFERRAL = 6;
   */
  REFERRAL = 6,

  /**
   * The browser read the referrer and there was none.
   *
   * @generated from enum value: ATTRIBUTION_CHANNEL_DIRECT = 7;
   */
  DIRECT = 7,

  /**
   * A landing on the download page, or the referral chip a recipient follows from our own host.
   *
   * @generated from enum value: ATTRIBUTION_CHANNEL_RECIPIENT_PAGE = 8;
   */
  RECIPIENT_PAGE = 8,

  /**
   * A download-page landing in the transfer-games test group that offers a game.
   *
   * @generated from enum value: ATTRIBUTION_CHANNEL_RECIPIENT_PAGE_GAME = 9;
   */
  RECIPIENT_PAGE_GAME = 9,

  /**
   * A download-page landing in the transfer-games test group that offers no game.
   *
   * @generated from enum value: ATTRIBUTION_CHANNEL_RECIPIENT_PAGE_CONTROL = 10;
   */
  RECIPIENT_PAGE_CONTROL = 10,

  /**
   * A landing on the request-files upload page.
   *
   * @generated from enum value: ATTRIBUTION_CHANNEL_REQUEST_PAGE = 11;
   */
  REQUEST_PAGE = 11,

  /**
   * A referral code was present, on a link other than the recipient page's own chip.
   *
   * @generated from enum value: ATTRIBUTION_CHANNEL_REFERRAL_INVITE = 12;
   */
  REFERRAL_INVITE = 12,
}

/**
 * Describes the enum kitecorp.transferify.account.v1.SubmitAttributionRequest.AttributionChannel.
 */
export const SubmitAttributionRequest_AttributionChannelSchema: GenEnum<SubmitAttributionRequest_AttributionChannel> = /*@__PURE__*/
  enumDesc(file_kitecorp_transferify_account_v1_account_attribution, 0, 0);

/**
 * How the signed-in holder reached the site, sent once the account exists (kitecorp/contracts#71).
 *
 * @generated from service kitecorp.transferify.account.v1.AccountAttributionService
 */
export const AccountAttributionService: GenService<{
  /**
   * Records the landing the holder arrived by. A repeat is not known to be harmless, so the call is left with unknown
   * idempotency and a client must not retry it on its own.
   *
   * @generated from rpc kitecorp.transferify.account.v1.AccountAttributionService.SubmitAttribution
   */
  submitAttribution: {
    methodKind: "unary";
    input: typeof SubmitAttributionRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_kitecorp_transferify_account_v1_account_attribution, 0);

